(function (scope) {
  'use strict';
  var categoryOrder = ['Jackets & Suits', 'Pants', 'Vests', 'Shirts', 'Neckwear', 'Accessories'];
  var collator = new Intl.Collator('en', {numeric: true, sensitivity: 'base'});
  function normalize(value) {
    return String(value == null ? '' : value).toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/\bgray\b/g, 'grey').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function searchNormalize(value) {
    return normalize(value).replace(/\bbowties?\b/g,'bow tie').replace(/\bneckties?\b/g,'long tie').replace(/\b(jackets|suits|vests|shirts|cummerbunds|shoes|ties|squares|ascots|cravats)\b/g,function(word){return word.slice(0,-1);});
  }
  function category(product) {
    return ({Jacket:'Jackets & Suits', Pants:'Pants', Vest:'Vests', Shirt:'Shirts', Neckwear:'Neckwear'})[product.type] || 'Accessories';
  }
  function values(product, key) { return Array.isArray(product[key]) ? product[key] : []; }
  function includesValue(product, key, value) { return !value || values(product,key).some(function (x) { return normalize(x) === normalize(value); }); }
  function corpus(product) {
    return searchNormalize([product.title,product.vendor,product.type,category(product)].concat(values(product,'skus'),values(product,'colors'),values(product,'colorFamilies'),values(product,'collections'),values(product,'neckwearTypes'),values(product,'fits')).join(' '));
  }
  function findProducts(products, filters) {
    filters = filters || {};
    var query=searchNormalize(filters.q), tokens=query.split(' ').filter(Boolean);
    return products.filter(function (p) {
      return (!filters.category || filters.category === 'All Photos' || category(p) === filters.category) &&
        (!filters.brand || normalize(p.vendor)===normalize(filters.brand)) &&
        (!filters.color || includesValue(p,'colorFamilies',filters.color) || includesValue(p,'colors',filters.color)) && includesValue(p,'collections',filters.collection) &&
        includesValue(p,'neckwearTypes',filters.subtype) && tokens.every(function (token) {return corpus(p).includes(token);});
    }).map(function (p) {
      var exact=values(p,'skus').some(function (sku) { return normalize(sku)===normalize(filters.q); });
      return {product:p,rank:query ? (exact ? 10000 : normalize(p.title)===query ? 2000 : normalize(p.title).startsWith(query) ? 100 : 0) : 0};
    }).sort(function (a,b) {
      return b.rank-a.rank || categoryOrder.indexOf(category(a.product))-categoryOrder.indexOf(category(b.product)) || collator.compare(a.product.title,b.product.title);
    }).map(function (entry) {return entry.product;});
  }
  function selectionSummary(products, ids, limits) {
    limits=limits || {maxProducts:25,maxPhotos:40};
    var unique=Array.from(new Set(ids.map(String))), lookup=new Map(products.map(function (p) {return [String(p.id),p];}));
    if(unique.length>limits.maxProducts) throw new Error('Choose up to '+limits.maxProducts+' styles per ZIP. Your selection is still here.');
    var photos=0;
    unique.forEach(function (id) {
      var product=lookup.get(id);
      if(!product) throw new Error('One selected style is no longer available. Remove it and try again.');
      if(!product.assets || !product.assets.length) throw new Error('This style does not have a downloadable photo yet.');
      photos+=product.assets.length;
    });
    if(photos>limits.maxPhotos) throw new Error('Choose up to '+limits.maxPhotos+' photos per ZIP. Split your selection into smaller downloads.');
    return {productIds:unique,styles:unique.length,photos:photos};
  }
  function packageUrl(base, ids, size) {
    if(!['original','web'].includes(size)) throw new Error('Choose an available photo size.');
    var url=new URL('/package',base);
    url.searchParams.set('productIds',ids.join(','));url.searchParams.set('size',size);
    return url.href;
  }
  function previewUrl(src, asset, width) {
    var url=new URL(src);
    url.searchParams.set('width',String(Math.max(1,Math.min(width,asset.width || width))));
    return url.href;
  }
  var api={normalize:normalize,category:category,findProducts:findProducts,selectionSummary:selectionSummary,packageUrl:packageUrl,previewUrl:previewUrl};
  if(typeof module!=='undefined' && module.exports) module.exports=api;
  if(scope) scope.BTWMediaCore=api;
})(typeof window==='undefined' ? null : window);
